module.exports = __webpack_public_path__ + "static/media/request.3df66c06.svg";